import styled from "styled-components";

import { PixelPlaceholderLoader, TitlePlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledListItemDescriptionLoader = styled(Stack)`
    gap: 4px;
`;

export const StyledLoaderWithGap = styled(PixelPlaceholderLoader)<{ marginTop?: string }>`
    margin-top: ${({ marginTop }) => marginTop};
`;

export const StyledTitleLoader = styled(TitlePlaceholderLoader)`
    height: 44px;
    width: 185px;
`;
